<!-- Sidenav -->
<app-sidebar></app-sidebar>
<!-- [ngClass]="{isVisible: isMinimize}" -->
<div class="main-content">
  <!-- Top navbar -->
  <app-navbar></app-navbar>
  <!-- Pages -->
  <router-outlet></router-outlet>
  <div class="container-fluid">
    <app-footer></app-footer>
  </div>
</div>

<!-- Rating Modal -->
<ng-template #inappmodal_rating let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Rate us</h4>
  </div>
  <div class="modal-body">
    <div class="row d-flex justify-content-center">
      <div class="col">
        <!-- Image -->
        <div class="row d-flex justify-content-center">
          <div class="col-8">
            <div class="ec_middle_item_container">
              <div class="ec_middle_container">
                <div class="svg_icon">
                  <img src="../../../assets/img/review_cover.svg">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Title -->
        <div class="row d-flex justify-content-center">
          <div class="col-8 text-primary text-center mt-4">
            <b>
              Your opinion matters to us!
            </b>
          </div>
        </div>
        <!-- Message -->
        <div class="row d-flex justify-content-center">
          <div class="col text-muted text-center mt-4">
            <p>
              We work hard to serve you better and would love to know <br>
              how would you rate our service?
            </p>
          </div>
        </div>
        <!-- Stars -->
        <div class="row d-flex justify-content-center">
          <div class="col-1"></div>
          <!-- (click)="selectRate(icon)" -->
          <div class="col svg_star p-0" *ngFor="let icon of rateIcons; let idx = index" (click)="selectRate(icon)">
            <img class="animate__animated animate__rubberBand" src="../../assets/rate/rate01inactive.svg"
              *ngIf="!ratingScoreCard[idx]">
            <img class="animate__animated animate__rubberBand" src="../../assets/rate/rate01active.svg"
              *ngIf="ratingScoreCard[idx]">
          </div>
          <div class="col-1"></div>
        </div>

        <!-- Notes -->
        <div class="row d-flex justify-content-center mt-4">
          <div class="col">
            <form [formGroup]="rateForm">
              <div class="form-group">
                <textarea class="form-control" formControlName="comment" id="exampleFormControlTextarea1" rows="3"
                  placeholder="Additional comments ..."></textarea>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close('Close click')">Submit</button>
  </div>
</ng-template>

<!-- Ads Modal -->
<ng-template #inappmodal_ads let-modal>
  <!-- <div class="modal-header">
    <h4 class="modal-title">Rate us</h4>
  </div> -->
  <div class="modal-body p-0">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <!-- Image -->
        <div class="row d-flex justify-content-center">
          <div class="col-12">
            <div class="ec_middle_item_container">
              <div class="ec_middle_container">
                <!-- <img src="../../../assets/img/ads/web_ads.jpg"> -->
                <carousel [cellsToShow]="1" 
                [cellWidth]="'100%'"
                [margin]="0"
                [arrows]="false"
                [dots]="true"
                [loop]="false"
                [autoplay]="true"
                [height]="350"
                [autoplayInterval]="2000">
                  <div class="carousel-cell" *ngFor="let item of promoCodes">
                    <img class="img-fluid" src="{{ item.img }}">
                  </div>
                </carousel>
              </div>
            </div>
          </div>
          <!-- Data -->
          <!-- <div class="col-6 d-flex flex-column my-auto ec_middle_text" *ngIf="promoCodes">
            <div class="row d-flex justify-content-center custom_title_ text-primary ec_title_25">
              <div class="col-lg-12 p-0">
                {{ promoCodes.name}}
              </div>
            </div>
            <div class="row d-flex justify-content-center mb-3">
              <div class="col-lg-12 p-0">
                <small class="text-primary">
                  {{ promoCodes.description}}
                </small>
              </div>
            </div>
            <div class="row d-flex justify-content-center">
              <div class="col-lg-12 p-0">
                <small class="text-primary">
                  Use :
                  <span class="font-weight-bold">
                    {{ promoCodes.code }}
                  </span>
                </small>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row d-flex justify-content-center mt-3 mb-3">
          <div class="col-lg-4 p-0">
            <button type="button" class="btn btn-primary btn-block rounded-pill"
              (click)="modal.close('discount')">Close</button>
          </div>
        </div>
        <!-- Image -->
      </div>
    </div>
  </div>
  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="modal.close('Close click')">Close</button>
  </div> -->
</ng-template>

<!-- Annoucement Modal -->
<ng-template #inappmodal_announcement let-modal>
  <div class="modal-body p-0">
    <div class="row d-flex justify-content-center">
      <div class="col">
        <!-- Image -->
        <div class="row d-flex justify-content-center">
          <div class="col-12 p-0">
            <div class="ec_middle_item_container">
              <div class="ec_middle_container">
                <img src="../../../assets/img/ads/popup.svg">
              </div>
            </div>
          </div>
        </div>
        <!-- Title -->
        <div class="row d-flex justify-content-center">
          <div class="col-8 text-primary text-center mt-4">
            <b class="custom_title_">
              Announcement
            </b>
          </div>
        </div>
        <!-- Message -->
        <div class="row d-flex justify-content-center mt-2 mb-4">
          <div class="col-lg-10 text-center">
            <p class="m-0">
              <small class="custom_sub_title_ text-muted ">
                {{ messageData.description }}
              </small>
            </p>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center mb-3">
        <div class="col-lg-6">
          <button type="button" class="btn btn-primary btn-block rounded-pill"
            (click)="modal.close('Close click')">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Open in device -->
<ng-template #inappmodal_checkapp let-modal>
  <div class="modal-body p-0">
    <div class="row d-flex justify-content-center">
      <div class="col">
        <!-- Image -->
        <div class="row d-flex justify-content-center">
          <div class="col-12 p-0">
            <div class="ec_middle_item_container">
              <div class="ec_middle_container">
                <img src="../../../assets/img/ads/popup.svg">
              </div>
            </div>
          </div>
        </div>
        <!-- Title -->
        <div class="row d-flex justify-content-center">
          <div class="col-8 text-primary text-center mt-4">
            <b class="custom_title_">
              Hello!
            </b>
          </div>
        </div>
        <!-- Message -->
        <div class="row d-flex justify-content-center mt-2 mb-4">
          <div class="col-lg-10 text-center">
            <p class="m-0">
              <small class="custom_sub_title_ text-muted ">
               For easy booking use our eCarga Shipper Mobile app.
              </small>
            </p>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center mb-3">
        <div class="col-lg-6">
          <button type="button" class="btn btn-primary btn-block rounded-pill"
            (click)="modal.close('Close click'); openOnApp()">Open</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
